import React from 'react'
import HistoryCard from './HistoryCard'

const divStyle = {
  overflow: "hidden"
}

const HistoryContainer = ({ data, contract }) => {
  return (
    <div className="containerRow" style={divStyle}>
      {data.map((data, index) => {
        return <HistoryCard data={data} key={index} contract={contract} />
      })}
    </div>
  )
}

export default HistoryContainer